module.exports = __webpack_public_path__ + "static/img/9.e9bd4c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/9.png
// module id = 3pQK
// module chunks = 0